module.exports = __webpack_public_path__ + "img/rcfwc.24b7eaa6.png";